export const SmtpEmailSettingType = "SMTP";
export const MsOAuthEmailSettingType = "MicrosoftOAuth";

/**
 * The possible types of email settings.
 *
 * This may be used as a discriminator to determine which type we have.
 */
export type EmailSettingType = typeof SmtpEmailSettingType | typeof MsOAuthEmailSettingType;

/**
 * Base type for email settings which may be displayed to a user.
 */
export interface EmailSettings {
  type : EmailSettingType,
}

/**
 * Specialisation of `EmailSettings` for SMTP email config.
 *
 * Note that we display a placeholder on-screen to indicate that a password
 * has been entered, but we never actually transmit the password here.  This is
 * intentional, for security reasons.
 */
export interface SmtpEmailSettings extends EmailSettings {
  type: typeof SmtpEmailSettingType,
  host : string,
  port : number,
  username : string,
}

/**
 * Specialisation of `EmailSettings` for Microsoft Exchange OAuth 2.0
 *
 * Note that we display a placeholder on-screen to indicate that a client secret
 * has been entered, but we never actually transmit the secret here.  This is
 * intentional, for security reasons.
 */
export interface MsOAuthEmailSettings extends EmailSettings {
  type: typeof MsOAuthEmailSettingType,
  tenantId : string,
  clientId : string,
}

/**
 * Parameters used to send a test email.
 */
export interface SendTestEmailParameters {
  /**
   * The email address to which the test email should be sent.
   */
  address : string,

  /**
   * Some randomly-generated unique data for the test email, so that test emails can be distinguished from one another.
   */
  uniqueData : string,
}
